export var MrzPipelineStepStatus;
(function (MrzPipelineStepStatus) {
    MrzPipelineStepStatus["SUCCESS"] = "success";
    MrzPipelineStepStatus["FAILED"] = "failed";
    MrzPipelineStepStatus["SKIPPED"] = "skipped";
})(MrzPipelineStepStatus || (MrzPipelineStepStatus = {}));
//# sourceMappingURL=mrz.types.js.map